export const environment = {
    pageTitle: 'Osafety Dev 1.0.6',
    host: 'https://osafety-dev-cus-api.azurewebsites.net',
    production: false,
    features: {
        operationalControl: true
    },
    reports: {
        workspaceId: 'd9850f95-270d-4b42-aaea-cac65e5b291e',
        inventoryReportId: '9bbb2b71-4513-4c64-86aa-b20699f22304',
        requestsReportId: 'a9215ef0-e84c-4f5a-bf55-d18c9619a981'
    },
    msalConfig: {
        auth: {
            clientId: '2b10eba2-cf82-4934-b089-7a3b0894e3a0',
            ui_locales: 'es',
           redirectUri: 'https://desarrollo.osafety360.com'
        },
    },
    apiConfig: {
        scopes: [
            'api://e7551187-3593-43da-8328-eb1210e198b0/osafety.fullaccess',
        ],
        uri: [
            'api/Auth',
            'api/hello',
            'api/Epp',
            'api/Corpaceros',
            'api/WorkCenter',
            'api/Position',
            'api/Company',
            'api/WorkCenter',
            'api/RequestReason',
            'api/EppRequest',
            'api/UserContract',
            'api/User',
            'api/Inspection',
            'api/Notification',
            'api/Mobile',
            'api/PowerBI',
            'api/ExternalCollaborator',
            'api/Area',
            'api/HrtRiskType',
            'api/HrtTemplate',
            'api/Contractor',
            'api/FormEngine',
        ]
    },
    b2cPolicies: {
        names: {
            signUpSignIn: "",
            resetPassword: "",
            editProfile: ""
        },
        authorities: {
            signUpSignIn: {
                authority: 'https://Osafety360B2C.ciamlogin.com/'
            },
            resetPassword: {
                authority: 'https://Osafety360B2C.ciamlogin.com/'
            },
            editProfile: {
                authority: "https://Osafety360B2C.ciamlogin.com/"
            }
        },
        authorityDomain: "https://Osafety360B2C.ciamlogin.com/"
    },
    paginationConfig: {
        viewRows: [5, 10, 50, 100],
        pageLinkSize: 3
    }
};
